var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[(!_vm.showAboutEmployee && _vm.slidesLoaded)?_c('slide-item',{attrs:{"slide":_vm.computedSlide,"buttons":_vm.buttons[_vm.current_slide]}}):(_vm.showAboutEmployee)?_c('about-employee'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }